import React from "react";

export default function ModeOfPayment({ data, onChange }) {
  const handleInputChange = (key, value) => {
    onChange({
      ...data,
      [key]: value,
    });
  };

  return (
    <div>
      <h2 className="text-xl font-bold mb-4">Mode of Payment</h2>
      <div className="grid grid-cols-2 gap-6">
        {/* Payment Method */}
        <div>
          <label className="block mb-1">Payment Method</label>
          <select
            value={data?.payment_type || ""}
            onChange={(e) => handleInputChange("payment_type", e.target.value)}
            className="w-full border border-gray-300 rounded-md p-2"
          >
            <option value="">Select Payment Method</option>
            <option value="self-pay">Self-Pay</option>
            <option value="insurance">Insurance</option>
          </select>
        </div>

        {/* Deposit Collected */}
        <div>
          <label className="block mb-1">Deposit Collected</label>
          <input
            type="text"
            value={data?.amount || ""}
            onChange={(e) => handleInputChange("amount", e.target.value)}
            className="w-full border border-gray-300 rounded-md p-2"
            placeholder="Enter Deposit Amount"
          />
        </div>

        {/* Bank Name */}
        <div>
          <label className="block mb-1">Bank Name (Optional)</label>
          <input
            type="text"
            value={data?.bank_name || ""}
            onChange={(e) => handleInputChange("bank_name", e.target.value)}
            className="w-full border border-gray-300 rounded-md p-2"
            placeholder="Enter Bank Name"
          />
        </div>

        {/* Transaction ID */}
        <div>
          <label className="block mb-1">Transaction ID</label>
          <input
            type="text"
            value={data?.trasaction_id || ""}
            onChange={(e) => handleInputChange("trasaction_id", e.target.value)}
            className="w-full border border-gray-300 rounded-md p-2"
            placeholder="Enter Transaction ID"
          />
        </div>

        {/* Purpose of Payment */}
        <div>
          <label className="block mb-1">Purpose of Payment</label>
          <textarea
            value={data?.purpose || ""}
            onChange={(e) => handleInputChange("purpose", e.target.value)}
            className="w-full border border-gray-300 rounded-md p-2"
            placeholder="Enter Purpose of Payment"
          ></textarea>
        </div>
      </div>
    </div>
  );
}
